<template>
  <footer class="footer">
    <div class="wrap">
      <div class="cols">
        <div class="col col--brand">
          <div class="brand">
            <span class="mark mono">苏</span>
            <b>职业选手苏屠</b>
          </div>
          <p class="muted">
            苏屠粉丝专属兼职做任务平台，任务简单、结算透明，回馈每一位新老粉丝。
          </p>
          <p class="tip">
            <span class="tag">安全提示</span>
            本站任务全程免费，绝不索要账号密码与任何费用。
          </p>
        </div>

        <div class="col">
          <h4>热门任务</h4>
          <ul>
            <li v-for="c in categories" :key="c.key">
              <router-link :to="`/task/${c.key}`">{{ c.name }}</router-link>
            </li>
          </ul>
        </div>

        <div class="col">
          <h4>关于我们</h4>
          <ul>
            <li><a href="#flow">参与流程</a></li>
            <li><a href="#faq">常见问题</a></li>
            <li><a href="#upcoming">其它挣米业务</a></li>
            <li><router-link to="/">返回首页</router-link></li>
          </ul>
        </div>

        <div class="col col--soon">
          <h4>其它挣米业务</h4>
          <p class="muted">更多赚钱玩法正在陆续更新，敬请期待…</p>
          <div class="soon-dots">
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>

      <div class="bottom">
        <span>© {{ year }} 职业选手苏屠 · 回馈新老粉丝福利</span>
        <span class="muted">收益因任务与投入时间而异，请理性参与 · 本站为演示站点</span>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { categories } from '@/data/site'

const year = new Date().getFullYear()
</script>

<style scoped>
.footer {
  margin-top: 60px;
  padding: 54px 0 30px;
  border-top: 1px solid var(--border);
  background: linear-gradient(180deg, rgba(255, 205, 120, 0.03), transparent);
}

.cols {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1.2fr;
  gap: 40px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  font-size: 17px;
}

.mark {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #241300;
  background: var(--grad-gold);
}

.muted {
  color: var(--muted);
  font-size: 14px;
}

.tip {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  font-size: 13px;
  color: var(--muted-2);
}

.col h4 {
  font-size: 15px;
  margin-bottom: 16px;
  letter-spacing: 0.04em;
}

.col ul li {
  margin-bottom: 10px;
}

.col ul a {
  color: var(--muted);
  font-size: 14px;
  transition: color 0.2s ease;
}

.col ul a:hover {
  color: var(--gold);
}

.soon-dots {
  display: flex;
  gap: 6px;
  margin-top: 14px;
}

.soon-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--gold-2);
  opacity: 0.4;
  animation: blink 1.4s infinite;
}

.soon-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.soon-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

.bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 44px;
  padding-top: 22px;
  border-top: 1px solid var(--border);
  font-size: 13px;
  color: var(--muted-2);
}

@keyframes blink {
  0%,
  100% {
    opacity: 0.25;
  }
  50% {
    opacity: 1;
  }
}

@media (max-width: 900px) {
  .cols {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }
}

@media (max-width: 560px) {
  .cols {
    grid-template-columns: 1fr;
  }
  .bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
